// extracted by mini-css-extract-plugin
export var button = "_b6-0";
export var icon = "_b6-1";